module.exports = __webpack_public_path__ + "img/colored-square.2f027ba9.svg";